import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEnvelope,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import "../../styles/components/header.css";
import logo from "../../images/logo.png";

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Zatvori mobilni meni kad se promijeni ruta
    setIsOpen(false);
  }, [location]);

  // Zaključavanje skrolanja tijela kada je meni otvoren
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-shapes">
        <div className="header-shape header-shape-1"></div>
        <div className="header-shape header-shape-2"></div>
        <div className="header-shape header-shape-3"></div>
      </div>

      <div className="main-header">
        <div className="container">
          <Link to="/" className="logo">
            <div className="logo-container">
              <img
                src={logo}
                alt="Beauty Concept Veronika"
                className="logo-image"
              />
              <div className="logo-text-container">
                <span className="logo-text-beauty">Beauty Concept</span>
                <span className="logo-text-veronika">Veronika</span>
              </div>
            </div>
          </Link>

          <nav className="main-nav">
            <ul className="nav-list">
              <li>
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Početna
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className={location.pathname === "/services" ? "active" : ""}
                >
                  Usluge
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className={location.pathname === "/gallery" ? "active" : ""}
                >
                  Galerija
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className={location.pathname === "/about" ? "active" : ""}
                >
                  O nama
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={location.pathname === "/contact" ? "active" : ""}
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <Link to="/booking" className="booking-button">
              <FontAwesomeIcon icon={faCalendarAlt} />
              <span>Rezerviraj</span>
            </Link>

            <button
              className={`menu-toggle ${isOpen ? "open" : ""}`}
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
          </div>
        </div>
      </div>

      <div className={`mobile-menu ${isOpen ? "show" : ""}`}>
        <div className="menu-overlay" onClick={() => setIsOpen(false)}></div>
        <div className="mobile-menu-container">
          <div className="mobile-shapes">
            <div className="mobile-shape mobile-shape-1"></div>
            <div className="mobile-shape mobile-shape-2"></div>
            <div className="mobile-shape mobile-shape-3"></div>
            <div className="mobile-shape mobile-shape-4"></div>
            <div className="mobile-shape mobile-shape-5"></div>
          </div>

          <button
            className="close-menu"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className="mobile-logo">
            <img src={logo} alt="Beauty Concept Veronika" />
            <div className="mobile-logo-text">
              <span className="logo-text-beauty">Beauty Concept</span>
              <span className="logo-text-veronika">Veronika</span>
            </div>
          </div>

          <ul className="mobile-nav">
            <li>
              <Link
                to="/"
                className={location.pathname === "/" ? "active" : ""}
                onClick={() => setIsOpen(false)}
              >
                Početna
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={location.pathname === "/services" ? "active" : ""}
                onClick={() => setIsOpen(false)}
              >
                Usluge
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className={location.pathname === "/gallery" ? "active" : ""}
                onClick={() => setIsOpen(false)}
              >
                Galerija
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={location.pathname === "/about" ? "active" : ""}
                onClick={() => setIsOpen(false)}
              >
                O nama
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={location.pathname === "/contact" ? "active" : ""}
                onClick={() => setIsOpen(false)}
              >
                Kontakt
              </Link>
            </li>
            <li className="mobile-booking-item">
              <Link
                to="/booking"
                className="mobile-booking-button"
                onClick={() => setIsOpen(false)}
              >
                <FontAwesomeIcon icon={faCalendarAlt} /> Rezerviraj termin
              </Link>
            </li>
          </ul>

          <div className="mobile-footer">
            <div className="mobile-contact">
              <a href="mailto:info@beautyconceptveronika.hr">
                <FontAwesomeIcon icon={faEnvelope} />{" "}
                info@beautyconceptveronika.hr
              </a>
            </div>

            <div className="mobile-social">
              <a
                href="https://instagram.com/beautyconceptveronika"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Posjeti nas na Instagramu"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
